<template>
    <header
        :class="additionalClass"
        class="header"
    >
        <div class="header__container">
            <div class="header__logo">
                <img :src="logoUrl" alt="фитмост">
            </div>
            <button
                v-if="store.auth"
                @click="storeAuth.logout"
                class="header__logout"
            >
                Выйти
            </button>
        </div>
    </header>
</template>

<script setup>

import {useAuthStore} from "@/js/stores/auth";
import {useStore} from "@/js/stores";

const store = useStore();
const storeAuth = useAuthStore();
const logoUrl = new URL('@/assets/images/fitmost-logo.svg', import.meta.url);

defineProps({
    additionalClass: {
        type: String,
        default: ''
    },
})

</script>

